<div class="btnFilterCheckbox" id="btnFilterCheckbox">
  <button
    [disabled]="list.length === 0"
    class="m-button m-button--outline btnFilterCheckbox_btn"
    (click)="show()"
  >
    <span class="btn-filterCheckbox_text">Filtrar</span>
    <svg class="c-icon btnFilterCheckbox_icon">
      <use xlink:href="#ic-filter"/>
    </svg>
  </button>
  <div class="btnFilterBody" [class.show]="isShow">
      <ul>
        <li class="" *ngFor="let subtask of list; index as i">
          <mat-checkbox
            (change)="handleCheckChange($event)"
            [value]="subtask">
            {{subtask}}
          </mat-checkbox>
        </li>
      </ul>
  </div>
</div>



